import { useQuery } from '@tanstack/react-query'
import {
  fetchConfigDoor,
  fetchPendingOpeningEvents,
  fetchStoreOpeningState,
} from '../queries/door.queries'

export const useConfigDoor = (storeId: number) =>
  useQuery({
    queryKey: ['doorConfig', storeId],
    queryFn: () => fetchConfigDoor(storeId),
  })

export const useStoreOpeningState = (storeId: number) =>
  useQuery({
    queryKey: ['storeOpeningState', storeId],
    queryFn: () => fetchStoreOpeningState(storeId),
  })

export const usePendingOpeningEvents = (storeId: number) =>
  useQuery({
    queryKey: ['pendingOpeningEvents', storeId],
    queryFn: () => fetchPendingOpeningEvents(storeId),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
  })
